import { useState, useEffect, useRef } from 'react';

import styles from './New_KeyboardButton.module.css'

const New_KeyboardButton = ({ shifted, capsPressed, setCapsPressed, shiftPressed, setShiftPressed, normalKey, shiftedKey, length = 1, onEnterClicked, onKeyPressed,
    onBackspacePressed, onTabClicked, onMouseDown }) => {

    const timeoutRef = useRef();

    const [value, setValue] = useState(normalKey);
    const [buttonStyle, setButtonStyle] = useState(styles.button);

    useEffect(() => {
        setValue(shifted ? shiftedKey : normalKey);
    }, [shifted])

    useEffect(() => {
        if (shiftPressed || capsPressed) {
            setButtonStyle(styles.button_selected);
        } else {
            setButtonStyle(styles.button);
        }
    }, [shiftPressed, capsPressed])

    const onMouseDown_handler = () => {
        console.log("down")
        switch (value) {
            case "shift":
                setShiftPressed(!shiftPressed);
                break;
            case "caps":
                setCapsPressed(!capsPressed);
                break;
            case "backspace":
                setButtonStyle(styles.button_selected);
                onBackspacePressed?.();
                break;
            case "enter":
                setButtonStyle(styles.button_selected);
                onEnterClicked?.();
                break;
            case "tab":
                setButtonStyle(styles.button_selected);
                onTabClicked?.();
                break;
            default:
                setButtonStyle(styles.button_selected);
                setShiftPressed(false);
                onKeyPressed?.(value);
                break;
        }

        timeoutRef.current = setTimeout(() => {
            setButtonStyle(styles.button);
        },800)

        onMouseDown?.();
    }

    const onMouseUp_handler = () => {
        console.log("up")

        switch (value) {
            case "shift":
                break;
            case "caps":
                break;
            case "backspace":
                setButtonStyle(styles.button);
                break;
            case "enter":
                setButtonStyle(styles.button);
                break;
            case "tab":
                setButtonStyle(styles.button);
                break;
            default:
                setButtonStyle(styles.button);
                break;
        }

        clearTimeout(timeoutRef.current);
    }

    return (
        <div className={styles.component} onPointerUp={() => onMouseUp_handler()} onPointerDown={() => onMouseDown_handler()}>
            <div className={buttonStyle} style={{ width: length * 120 }}>
                {value}
            </div>
        </div>
    );
}

export default New_KeyboardButton;